// *** "use strict";
import AWS from "aws-sdk";
import React from 'react';
import { Paper } from 'material-ui';
// *** import { userIdFunc, handleErrorFunc } from '../App';
import appConfig from '../appConfig';

class LogoutView extends React.Component {
// ***  constructor(props) {
// ***    super(props);
// ***  }
  componentDidMount() {
      localStorage.removeItem('email');
      localStorage.removeItem('username');

       console.log("##### before expired="+AWS.config.credentials.expired); // false

      AWS.config.region = appConfig.region;
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: appConfig.IdentityPoolId
      });
      AWS.config.credentials.refresh(function(){
        // identityIdは残るがアクセス権はなくなっている
        var identityId = AWS.config.credentials.identityId;
        console.log("AWS.config.credentials.refresh ok : identityId="+identityId)
        console.log("##### after expired="+AWS.config.credentials.expired); // true

      })

      setTimeout( ()=>this.props.history.push({pathname: '/'}) ,3000) ;
  }


  render () {
    return (
      <div style={{width: 400, margin: "auto"}}>
        <Paper zDepth={3} style={{padding: 32, margin: 32}}>
          ログアウト成功！
        </Paper>
      </div>
    );
  }
}
export default LogoutView;



// WEBPACK FOOTER //
// ./src/views/LogoutView.js